export enum ENV {
  DMAS = "DMAS_CONFIG_URL",
  SAS = "SAS_CONFIG_URL",
}
